import React, { useState, useEffect } from "react";
import Header from "../../layout/Header";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Leftpanel from "../../layout/Leftpanel";
import Qualitylist from "./Qualitylist";
import { Button, Modal } from "react-bootstrap";
import {
  deleteQualityControl,
  getQualityContorl,
  getAllQuallityControllist,
} from "../../../../service/QualityControl/QualityControlService";
import instance from "../../../../WebApi/WebApi";
import { useTranslation } from "react-i18next";

const Qualitycontrol = () => {
  const { t } = useTranslation();
  const [showDelete, setShowDelete] = useState(false);
  const [deleteQualityControlId, setDeleteQualityControlId] = useState("");

  const [inputList, setInputList] = useState("");
  const [textChange, setTextChange] = useState("");

  const [items, setItems] = useState([]);
  const [editId, setEditId] = useState();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [qualityControlList, setAllQualityControlList] = useState([]);

  const handleCloseDelete = () => setShowDelete(false);
  const handleEditClose = () => setEditModalOpen(false);

  useEffect(() => {
    getQualityControlDataList();
  }, []);

  async function getQualityControlDataList() {
    getAllQuallityControllist().then(function (result) {
      const response = result.data;
      setAllQualityControlList(response.data.qualityControlList);
    });
  }

  const itemEvent = (event) => {
    setInputList(event.target.value);
  };

  const listItems = () => {
    if (inputList === "") {
      toast.error("Please type a question");
    } else {
      getQualityContorl(inputList, (r) => {
        if (r.success === true) {
          setInputList("");
          // setPercentage('');
          toast.success(r.message);
          getQualityControlDataList();
        } else {
          toast.error(r.message);
        }
      });
    }
  };

  const onDelete = (data) => {
    setDeleteQualityControlId(data);
    console.log(data, "datadatadatadatadatadata");
    setShowDelete(true);
  };

  const onYes = () => {
    deleteQualityControl(deleteQualityControlId, (res) => {
      console.log(res, "response");
      if (res.success === true) {
        toast.success(res.message);
        setShowDelete(false);
        getQualityControlDataList();
      } else {
        toast.error(res.message);
      }
    });
  };

  const onNo = () => {
    setShowDelete(false);
  };

  const onEdit = (data) => {
    setTextChange(data?.text);
    setEditId(data?.id);
    setEditModalOpen(true);
  };
  const update = async () => {
    const data = {
      qualityControlId: editId,
      text: textChange,
    };
    try {
      const res = await instance.post(
        `/customer/qualityControl/edit-quality-control`,
        data
      );
      if (res?.data?.success) {
        toast.success(res?.data?.message);
        handleEditClose();
        getQualityControlDataList();
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="container-fluid">
      <div className="dbMain qualityCbg">
        <Leftpanel breadcm="Other" />
        <div className="dbRight">
          <Header
            link="/dashboard"
            title={t("quality_questions")} // Use translation
            description=""
          />
          <div className="commonBase mb-4">
            <h6 className="mb-3">{t("add_question")}</h6>{" "}
            {/* Use translation */}
            <div className="additembox">
              <input
                type="text"
                className="form-control"
                placeholder={t("add_question_placeholder")} // Use translation
                value={inputList}
                onChange={itemEvent}
                style={{ width: "87%" }}
              />
              <button onClick={listItems} className="commonButton">
                <span>
                  <i className="fa-solid fa-plus"></i>
                </span>{" "}
                {t("add")} {/* Use translation */}
              </button>
            </div>
            <ul className="qualityLists">
              {qualityControlList?.map((d) => (
                <li className="addQualitylist" key={d?.text}>
                  <p>{d?.text}</p>
                  <i className="fa-light fa-pen" onClick={() => onEdit(d)}></i>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Modal show={editModalOpen} onHide={handleEditClose}>
          <Modal.Header closeButton style={{ border: "none" }}>
            <Modal.Title>{t("update_question")}</Modal.Title>{" "}
            {/* Use translation */}
          </Modal.Header>
          <Modal.Body>
            <input
              type="text"
              className="form-control"
              value={textChange}
              onChange={(e) => setTextChange(e.target.value)}
            />
          </Modal.Body>
          <Modal.Footer style={{ border: "none" }}>
            <Button variant="primary" className="commonButton" onClick={update}>
              {t("update")} {/* Use translation */}
            </Button>
            &nbsp;
            <Button
              variant="danger"
              style={{ borderRadius: "20px" }}
              onClick={handleEditClose}
            >
              {t("close")} {/* Use translation */}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showDelete} onHide={handleCloseDelete}>
          <Modal.Header closeButton>
            <Modal.Title>{t("delete_confirmation")}</Modal.Title>{" "}
            {/* Use translation */}
          </Modal.Header>
          <Modal.Body>
            <Button variant="primary" className="commonButton" onClick={onYes}>
              {t("yes")} {/* Use translation */}
            </Button>
            &nbsp; &nbsp; &nbsp; &nbsp;
            <Button variant="primary" className="commonButton" onClick={onNo}>
              {t("no")} {/* Use translation */}
            </Button>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default Qualitycontrol;
